<template>
    <div class="row">
        <div class="col-xl-12 mb-3">
            <h6 class="text-center mb-4"><i class="fa fa-search mr-1"></i> Search Order</h6>
        </div>
        <div class="col-xl-4 col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h6>Enter An Order Id</h6>
                    <p v-if="error" class="text-danger">{{ error }}</p>
                    <orders-form :loading="loading" @submit="onSubmit"></orders-form>
                </div>
            </div>
        </div>
        <div class="col-xl-8 col-lg-12">
            <div class="card">
                <div class="card-body">
                    <pagination-table
                        :data="orderHistory"
                        :propsToSearch="['id', USERS.fields.email]"
                        searchPlaceholder="Search id, email"
                        title="Search Order History"
                    >
                        <template slot="table" slot-scope="scope">
                            <order-history-table :data="scope.data"></order-history-table>
                        </template>
                    </pagination-table>
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <pagination-table
                        :data="actionNeededOrders"
                        :propsToSearch="['id', USERS.fields.email]"
                        searchPlaceholder="Search id, email"
                        title="Action Needed Orders"
                        icon="fa fa-exclamation-circle"
                    >
                        <template slot="table" slot-scope="scope">
                            <order-history-table :data="scope.data"></order-history-table>
                        </template>
                    </pagination-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { USERS } from 'db'
import PaginationTable from 'Shared/Tables/PaginationTable'
import OrderHistoryTable from 'Shared/Tables/OrderHistoryTable'
import OrdersForm from 'Shared/Forms/OrdersForm'
export default {
    components: {
        OrdersForm,
        PaginationTable,
        OrderHistoryTable
    },
    data() {
        return {
            USERS,
            loading: false,
            error: false
        }
    },
    computed: {
        orderHistory() {
            const orderHistory = this.$store.getters['orders/GET_ORDER_HISTORY']
            return Object.keys(orderHistory).map((orderId) => ({
                id: orderId,
                ...orderHistory[orderId]
            }))
        },
        actionNeededOrders() {
            return this.$store.getters['orders/GET_ORDERS']
        },
        async() {
            return this.$store.getters['orders/GET_ASYNC']
        }
    },
    created() {
        this.$store.dispatch('orders/FETCH_ACTION_NEEDED_ORDERS')
    },
    methods: {
        async onSubmit(values) {
            this.loading = true
            try {
                const order = await this.$store.dispatch('orders/SEARCH_ORDER_BY_ID', {
                    id: values.id
                })
                if (!order) this.error = 'No order with that id was found'
                else if (order) {
                    this.$router.push({ name: 'order', params: { id: values.id } })
                    this.$store.commit('orders/APPEND_ORDER_HISTORY', {
                        id: order.id,
                        ...order,
                        searchTimestamp: Date.now()
                    })
                    localStorage.setItem(
                        'verdaSupportLastOrder',
                        JSON.stringify({
                            id: values.id
                        })
                    )
                }
            } catch (err) {
                this.error = err.message
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
